import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { DialogActions } from '@mui/material';
import GhostButton from '../button/GhostButton';
import PrimaryButton from '../button/PrimaryButton';
import { BodyText, Subheading } from '../typography/PrimaryTypography';

/**
 * A global modal for confirming navigation away from Syntiro.
 * @param {boolean} open The display state of the modal.
 * @param {string} title The header text of the modal.
 * @param {string} description The additional descriptive text of the action.
 * @param {string} external_link The external link to be navigated to upon confirmation.
 * @param {void} handleCloseModal Handler to close the modal.
 * @returns {JSX.Element}
 */
const ExternalNavigationModal = ({
  open,
  title,
  description,
  external_link,
  handleCloseModal
}: {
  open: boolean;
  title: string;
  description: string;
  external_link: string;
  handleCloseModal: () => void;
}) => {
  return (
    <Dialog open={open} onClose={handleCloseModal}>
      <Subheading weight="Bold" sx={{ m: 2 }}>
        {title}
      </Subheading>
      <DialogContent>
        <BodyText id="explainer">{description}</BodyText>
        <DialogActions sx={{ mt: 2 }}>
          <GhostButton dark onClick={handleCloseModal}>
            Cancel
          </GhostButton>
          <a
            href={external_link}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => handleCloseModal()}
          >
            <PrimaryButton>Continue</PrimaryButton>
          </a>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default ExternalNavigationModal;
